import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/GaoDeMap/ModalMapView.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-home page-new-home"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [+_vm.codeMap['90008'] ? _c('Banner', {
    attrs: {
      "bannerList": _vm.bannerList
    },
    on: {
      "on-click": _vm.handleFuncJump
    }
  }) : _vm._e(), +_vm.codeMap['90001'] ? _c('HomeCard', {
    attrs: {
      "codeMap": _vm.codeMap
    }
  }) : _vm._e(), +_vm.codeMap['90009'] ? _c('Notice', {
    class: {
      mb2: !+_vm.codeMap['90008']
    },
    attrs: {
      "noticeList": _vm.noticeList
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !+_vm.codeMap['90009'] || !+_vm.codeMap['90008'] || !+_vm.codeMap['90001'],
      expression: "!+codeMap['90009'] || !+codeMap['90008'] || !+codeMap['90001']"
    }],
    staticClass: "line"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.funNavList.length > 0 && +_vm.codeMap['90010'],
      expression: "funNavList.length > 0 && +codeMap['90010']"
    }],
    staticClass: "functionalArea"
  }, [_c('div', {
    staticClass: "big-box"
  }, _vm._l(_vm.funNavList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-box",
      on: {
        "click": function ($event) {
          return _vm.handleFuncJump(item);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.image_url || '/spa_static/editIcon/server-4.png'
      }
    }), _c('span', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selfCheckList.length > 0 && +_vm.codeMap['90011'],
      expression: "selfCheckList.length > 0 && +codeMap['90011']"
    }],
    staticClass: "selfCheckBox"
  }, [_c('div', {
    staticClass: "smy__header-title"
  }, [_c('div', {
    staticClass: "smy__title"
  }, [_vm._v(i18n.tc("29"))])]), _c('div', {
    staticClass: "selfCheck"
  }, _vm._l(_vm.selfCheckList, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "selfCheck-item1",
      on: {
        "click": function ($event) {
          return _vm.handleJump(index);
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _c('p', [_vm._v(_vm._s(item.descri))]), _c('img', {
      staticClass: "img",
      attrs: {
        "src": item.image_url,
        "alt": ""
      }
    })])]);
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: +_vm.codeMap['90001'],
      expression: "+codeMap['90001']"
    }],
    staticClass: "selfCheckBox"
  }, [_c('div', {
    staticClass: "smy__header-title"
  }, [_c('div', {
    staticClass: "smy__title"
  }, [_vm._v(i18n.tc("31"))])]), _c('div', {
    staticClass: "contactUs"
  }, [+_vm.codeMap['90004'] ? _c('div', {
    staticClass: "contactUs-box"
  }, [_c('div', {
    staticClass: "iconBox1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("@/assets/img/MH3.9/iphone.png"),
      "alt": ""
    }
  }), _c('h2', [_vm._v(i18n.tc("32"))])]), _c('div', {
    staticClass: "iconBox"
  }, [_c('a', {
    staticClass: "main-color",
    attrs: {
      "href": "tel:" + _vm.codeMap['40011']
    }
  }, [_vm._v(_vm._s(_vm.codeMap['40011']))]), _c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/right-arrow.png"),
      "alt": ""
    }
  })])]) : _vm._e(), +_vm.codeMap['90006'] ? _c('div', {
    staticClass: "contactUs-box"
  }, [_c('div', {
    staticClass: "iconBox1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("@/assets/img/MH3.9/address.png"),
      "alt": ""
    }
  }), _c('h2', [_vm._v(i18n.tc("33"))])]), _c('div', {
    staticClass: "iconBox",
    on: {
      "click": function ($event) {
        _vm.showtMapAddress = true;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.codeMap['40013']))]), _c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/right-arrow.png"),
      "alt": ""
    }
  })])]) : _vm._e(), +_vm.codeMap['90005'] ? _c('div', {
    staticClass: "contactUs-box"
  }, [_c('div', {
    staticClass: "iconBox1"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("@/assets/img/MH3.9/email.png"),
      "alt": ""
    }
  }), _c('h2', [_vm._v(i18n.tc("34"))])]), _c('div', {
    staticClass: "iconBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.codeMap['40012']))])])]) : _vm._e()])])], 1), _c(__unplugin_components_0, {
    attrs: {
      "address": _vm.codeMap['40013'],
      "center": _vm.center
    },
    model: {
      value: _vm.showtMapAddress,
      callback: function ($$v) {
        _vm.showtMapAddress = $$v;
      },
      expression: "showtMapAddress"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };